import styled from 'styled-components'
import { color, above, costaText, costaTextBold } from 'ui/src/styles/index'

interface StyledButtonProps {
  isActive: boolean
}

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: flex-start;
  gap: 14px 24px;

  ${above.tablet`
    gap: 24px;
    `}
`

export const StyledButton = styled.button<StyledButtonProps>`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  background: ${({ isActive }) => (isActive ? color.backgroundCreammy : color.white)};
  border: none;
  margin: 0;
  cursor: pointer;
  padding: 0;
  width: 88px;
  min-height: 88px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  ${above.tablet`
      width: 132px;
      height: 132px;
    `}

  &.disabled,
  &:disabled {
    display: none !important;
  }
  
  &:hover {
    background: ${({ isActive }) => (isActive ? color.backgroundCreammy : color.white)};
  }
  

  span {
    color: ${color.costaRedFont};

    padding: 0 5px 8px;
    font-size: 12px;
    ${({ isActive }) => (isActive ? costaTextBold : costaText)};
    width: 100%;
    text-align: center;
    word-wrap: break-word;

    ${above.tablet`
        font-size: 16px;
      `}
  }

  }
`

export const StyledCustomiseDrink = styled.div`
  h3 {
    margin: 0;
  }
`

export const DrinkCaption = styled.p`
  margin: 40px 0 24px;
  color: ${color.costaRedFont};
  font-size: 16px;
  line-height: 19.2px;

  ${above.tablet`
    font-size: 24px;
    line-height: 28.8px
    margin-bottom: 24px;
  `}
`
